/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../NonNumericFilterController',
	'../NonNumericFilterModel'
], function(_, BaseClass, FilterModel) {
	'use strict';

	var NonNumericLocalFilterController = BaseClass.extend({
		// @overrides
		init: function(options) {
			NonNumericLocalFilterController.inherited('init', this, arguments);
			this.id = _.uniqueId('NonNumericLocalFilterController');
			this.itemContext.eventSourceId = this.id;
			this.isProperty = this.metadataInfo.isProperty;
			// Determine if the md column explicitly prohibits search and filter conditions.
			this.doesMetadataSupportFilterConditionsAndSearch  = this.metadataInfo.supportsConditionFilters;
			this.viewConfig = {
				commonView: this.commonView,
				dashboardApi: this.dashboardApi,
				showCondition: this.getShowCondition(),
				allowSearch: this.doesMetadataSupportFilterConditionsAndSearch
			};
			this.visualization = options.visualization;
			this.localFilters = this.visualization.getLocalFilters();

			// ignore the aggregation for list filter
			delete this.itemContext.aggregationType;
		},

		_initializeExtraData: function () {},

		_createFilterModel: function() {
			var modelOptions = {
				name: this.itemContext.itemName,
				list: []
			};
			this.model = new FilterModel(modelOptions);
		},

		onDone: function() {
			if (this.model.onDone) {
				this.model.onDone();
			}
			var conditionsInfo;
			if (this.model.condition) {
				conditionsInfo = {
					excludedValues: this.model.getExcludedMembersArray(),
					conditions: this.queryHelper.convertFromConditionsToQueryFilters(this.model.condition)
				};
			}

			var filterSpec;
			// When a full set is selected, the filter is based on the item id.
			const isAllMembersOfTheSetToggled = this.getShowToggle() && this.model.getIsToggled();
			if (isAllMembersOfTheSetToggled) {
				filterSpec = {
					exclude: false,
					valueDataItem: this.itemContext.itemId
				};
			} else {
				filterSpec = {
					exclude: this.model.getInvert(),
					values: this.model.getIncludedMembersArray(),
					conditionsInfo: conditionsInfo
				};
			}
			if (this.isProperty) {
				filterSpec.type = 'display';
			}

			// Invert will set the exclude to true and values is empty in filterSpec
			if (!isAllMembersOfTheSetToggled && _.isEmpty(filterSpec.values) && _.isEmpty(filterSpec.conditionsInfo) && !filterSpec.exclude) {
				this.localFilters.removeFilter(this.itemContext);
			} else if (this.localFilters.filterExists(this.itemContext)) {
				this.localFilters.editFilter(this.itemContext, filterSpec);
			} else {
				this.localFilters.addFilter(this.itemContext, filterSpec);
			}

			if (!this.view.isCompact) {
				this.view.remove();
			}
			if (this.commonView.remove) {
				this.commonView.remove();
			}
		},

		// @overrides
		getShowCondition: function() {
			return this.doesMetadataSupportFilterConditionsAndSearch;
		},

		// @overrides
		_refreshModel: function() {
			this.model.clearValues();

			const filter = this._getFilter();
			if (filter) {
				if (filter.conditions) {
					const convertedConditions = this.queryHelper.convertFromQueryFiltersToConditions(filter.conditions);
					this.model.setCondition(convertedConditions);
					this.setLastFilterCondition(convertedConditions);
					this.model.setExcludedMembers(filter.excludedValues);
					this.applyFilterCondition(convertedConditions);
				}
				this.model.setSelectedMembers(filter.values);
				this.model.setIncludedMembers(filter.values);
				this.model.setInvert(filter.operator.indexOf('not') >= 0 ? true : false);
			}
		},

		_getFilter: function() {
			return _.find(this.localFilters.getFilterList(), filter => {
				return filter.columnId === this.itemContext.itemId;
			});
		},

		onClose: function() {
			NonNumericLocalFilterController.inherited('onClose', this, arguments);
			if (this.commonView.remove) {
				this.commonView.remove();
			}
		}

	});
	return NonNumericLocalFilterController;
});
